export type TestCaseEntity = 'annotator' | 'campaign' | 'rule';

export const entityToQueryMap: Record<TestCaseEntity, string> = {
  annotator: 'annotator_uuids',
  campaign: 'campaign_uuids',
  rule: 'rule_uuids',
};
